'use client';
import { setStore } from '../index.js';

function StoreInitClient(props) {
  setStore(props);
  return null;
}
StoreInitClient.displayName = "StoreInitClient";

export { StoreInitClient };
//# sourceMappingURL=client.js.map
